export function WorkOrderService($http, apexApiUrl) {
    'ngInject'
    return {
        retrieveWorkOrders: retrieveWorkOrders,
        retrieveWorkOrder: retrieveWorkOrder,
        createWorkOrder: createWorkOrder,
        bulkCreateWorkOrders: bulkCreateWorkOrders,
        patchWorkOrder: patchWorkOrder,
        retrieveProductOrderStatuses: retrieveProductOrderStatuses,
        createWorkOrderEmployeeClaim: createWorkOrderEmployeeClaim,
        sendWorkOrderUpdateAlert: sendWorkOrderUpdateAlert,
        bulkRemoveProductOrderStatus: bulkRemoveProductOrderStatus
    };

    /**
     * Retrieve work order that match the filters provided in the given query object.
     * @param {GetWorkOrdersQuery} query
     */
    function retrieveWorkOrders(query) {
        return $http({
            method: "GET",
            url: apexApiUrl + "work-orders",
            params: query,
            headers: { Accept: "application/json" }
        })
            .then(function (response) {
                return response.data;
            })
    }

    /**
     * Retrieve the work order with the given ID.
     * @param {Number} workOrderID
     */
    function retrieveWorkOrder(workOrderID) {
        return $http({
            method: "GET",
            url: apexApiUrl + "work-orders/" + workOrderID,
            headers: { Accept: "application/json" }
        })
            .then(function (response) {
                return response.data;
            })
    }

    /**
     * Create a new work order from the given request.
     * @param {any} workOrderCreateRequest
     */
    function createWorkOrder(workOrderCreateRequest) {
        return $http({
            method: "POST",
            url: apexApiUrl + "work-orders",
            data: workOrderCreateRequest,
            headers: { "Content-Type": "application/json", Accept: "application/json" }
        }).then(function (response) {
            return response.data;
        });
    }

    /**
     * Bulk create or update all work orderss for each request in the list.
     * @param {any} workOrdersCreateRequests
     */
    function bulkCreateWorkOrders(workOrdersCreateRequests) {
        return $http({
            method: "POST",
            url: apexApiUrl + "work-orders/bulk",
            data: workOrdersCreateRequests,
            headers: { "Content-Type": "application/json" }
        });
    }

    /**
     * Patch the work order with the given ID with the provided patch data.
     * @param {any} leadWorkOrderID
     * @param {any} leadWorkOrderPatchRequest
     */
    function patchWorkOrder(workOrderID, workOrderPatchRequest) {
        return $http({
            method: "PATCH",
            url: apexApiUrl + "work-orders/" + workOrderID,
            data: workOrderPatchRequest,
            headers: { "Content-Type": "application/json" }
        });
    }

    /**
   * Get all the work order statuses for the given division.
   * @param {any} divisionID
   */
    function retrieveProductOrderStatuses(divisionID) {
        return $http({
            method: "GET",
            url: `${apexApiUrl}/divisions/${divisionID}/product-order-statuses`,
            headers: { "Content-Type": "application/json" }
        }).then(function (response) {
            return response.data;
        });
    }

    /**
     * Submit a work order employee claim to assign the given employee to the work order.
     * @param {any} request
     */
    function createWorkOrderEmployeeClaim(request) {
        return $http({
            method: "POST",
            url: apexApiUrl + "work-orders/employee-claims",
            headers: { "Content-Type": "application/json" },
            data: request
        });
    }

    /**
    * Bulk remove/update product order status
    * @param {any} productOrderStausRemoveRequests
    */
    function bulkRemoveProductOrderStatus(productOrderStausRemoveRequests) {
        return $http({
            method: "PATCH",
            url: apexApiUrl + "product-order-status/bulk",
            data: productOrderStausRemoveRequests,
            headers: { "Content-Type": "application/json" }
        });
    }

    function sendWorkOrderUpdateAlert(request) {
        return $http({
            method: "POST",
            url: apexApiUrl + "work-orders-update-alert",
            headers: { "Content-Type": "application/json" },
            data: request
        });
    }
}
